export default __webpack_public_path__ + "static/media/Setting_Dreamless.28eed9f4.svg";